// use-api.ts — Api suite, primary public hook
//
// Returns the typed ApiRoutes from @cabal/shared/api-client. This is the only hook
// the vast majority of the codebase needs from the api suite.
//
// The other surfaces of the api context (`applyAuth`, version metadata) are exposed
// via co-located hooks (use-apply-auth.ts) and are intended for the auth suite only.

'use client';

import type { ApiRoutes } from '@cabal/shared/api-client';
import { useApiContext } from './ApiProvider';

export function useApi(): ApiRoutes {
  return useApiContext().routes;
}
